/**
 * Whether this page is inside a frame. A cross-origin parent makes reading `window.top` throw in
 * some browsers, which also means framed. Its own module so tests can say either way.
 */
export const isFramed = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
